var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUs = function SvgUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#584b34aa-04e0-462e-a841-f645e3bc6c89a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "26942c63-6d77-4b39-bfe7-e23ff94072a9b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#26942c63-6d77-4b39-bfe7-e23ff94072a9b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444379",
    fillRule: "evenodd",
    d: "M0 0h9v7H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7B6E7",
    fillRule: "evenodd",
    d: "M1 1v1h1V1zm2 0v1h1V1zm2 0v1h1V1zm2 0v1h1V1zM6 2v1h1V2zM4 2v1h1V2zM2 2v1h1V2zM1 3v1h1V3zm2 0v1h1V3zm2 0v1h1V3zm2 0v1h1V3zM1 5v1h1V5zm2 0v1h1V5zm2 0v1h1V5zm2 0v1h1V5zM6 4v1h1V4zM4 4v1h1V4zM2 4v1h1V4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED4C49",
    fillRule: "evenodd",
    d: "M9 0v1h12V0zm0 2v1h12V2zm0 2v1h12V4zm0 2v1h12V6zM0 8v1h21V8zm0 2v1h21v-1zm0 2v1h21v-1zm0 2v1h21v-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "584b34aa-04e0-462e-a841-f645e3bc6c89a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgUs;